import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, departmentDetailFeatureKey } from './department-detail.reducer';

export const departmentDetailFeature = createFeatureSelector<State>(departmentDetailFeatureKey);

export const getDepartment = createSelector(departmentDetailFeature, (state) => {
   return state.department;
});

export const getDepartmentCallState = createSelector(departmentDetailFeature, (state) => {
   return state.callState;
});
